export const initialIbanRegionsState = {
    ibanRegions: [],
};
  
export interface IIbanRegionsState {
    ibanRegions: any[],
}
  